module.exports = __webpack_public_path__ + "img/banner-2.4177aa42.jpg";